export default "__VITE_ASSET__1030b299__"